// 变化通知：整个页签只开一条长轮询连接（由 Layout 启动），后端一有写入（新消息、状态流转、
// 派单、转接、改名……）就返回新版本号，没变化最多挂 25 秒再回。各页面用 onChange 订阅，
// 收到通知再去拉自己关心的数据。
// 替代原来工作台每 5 秒盲拉 4 个接口（一个人开一天约 3 万次请求）：空闲时每 25 秒 1 次，
// 有变化时比 5 秒轮询更快到。后端不发通知的变化（运营心跳超时掉线）由各页面自己的 60 秒兜底刷新补。
import { api, auth } from './api.js'

const listeners = new Set()
let ver = null      // 后端当前版本号；null = 还没拿到过
let stopFn = null   // 正在跑的那条循环的停止函数；null = 没在跑

export function onChange(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

const sleep = ms => new Promise(r => setTimeout(r, ms))

export function startChangeFeed({ presence = false } = {}) {
  if (stopFn) return
  let alive = true
  let fails = 0
  stopFn = () => { alive = false; stopFn = null }
  ;(async () => {
    while (alive && auth.token) {
      try {
        const r = await api.waitChanges(ver, presence)
        fails = 0
        if (!alive) break
        if (presence) window.dispatchEvent(new Event('workbench-connected'))
        if (r?.ver === ver) continue    // 挂到超时也没变化，接着挂
        const first = ver === null
        ver = r.ver
        // 第一次只是对上版本号，页面挂载时已经各自拉过数据，不用再刷一遍
        if (!first) for (const fn of [...listeners]) { try { fn(ver) } catch {} }
      } catch {
        // 401 时 api 已经清掉令牌并跳登录页，循环条件自然退出；其余错误（网络断、后端重启）退避重连
        if (!alive || !auth.token) break
        await sleep(Math.min(30 * 1000, 1000 * 2 ** Math.min(fails++, 5)))   // 1s、2s、4s…最多 30s
      }
    }
    if (alive) stopFn = null   // 因为令牌没了而退出的，把状态清掉，下次登录能重新启动
  })()
}

export function stopChangeFeed() { stopFn?.() }
